import { message } from "antd";
import type { ReactNode } from "react";
import type { ArgsProps } from "antd/es/message";
import styles from "./styles.module.scss";

type MessageCallerData = Omit<ArgsProps, "content"> & { text: ReactNode };

type MessageCaller = (data: MessageCallerData) => void;

export const useAlert = () => {
  const callSuccess: MessageCaller = ({ text, ...data }) => {
    message.success({
      content: text,
      className: styles.success,
      ...data,
    });
  };
  const callError: MessageCaller = ({ text, ...data }) => {
    message.error({
      content: text,
      className: styles.error,
      ...data,
    });
  };
  const callInfo: MessageCaller = ({ text, ...data }) => {
    message.info({
      content: text,
      className: styles.info,
      ...data,
    });
  };
  const destroyAll = () => {
    message.destroy();
  };
  const destroy = (key: string) => {
    message.destroy(key);
  };

  return { callError, callSuccess, callInfo, destroyAll, destroy };
};
